<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success" style="margin-bottom: 0;"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          No：{{ formData.amzReplenishmentNo || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          {{ formData.amzPeriodTitle || '' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <el-tag
          size="mini"
          :type="
            formData.replenishmentStatus === 'N'
              ? 'primary'
              : formData.replenishmentStatus === 'D'
              ? 'danger'
              : formData.replenishmentStatus === 'P'
              ? 'warning'
              : formData.replenishmentStatus === 'Y'
              ? 'success'
              : formData.replenishmentStatus === 'S'
              ? 'logistics'
              : 'info'
          "
        >
          {{ formData.v_replenishmentStatus }}
        </el-tag>
        <el-divider direction="vertical"></el-divider>
        <el-tag
          v-if="formData.v_skuSalesChannel"
          size="mini"
          :type="
            formData.skuSalesChannel === 'F'
              ? 'success'
              : formData.skuSalesChannel === 'V'
              ? 'warning'
              : ''
          "
        >
          {{ formData.v_skuSalesChannel }}
        </el-tag>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyDate || '--' }}
        </span>
      </div>
    </div>
    <SkuTable
      v-if="disabled && !!amzReplenishmentCode"
      :amzReplenishmentCode="amzReplenishmentCode"
      :isVc="isVc"
    />
    <SetScmFbaTable
      v-else-if="!!amzReplenishmentCode"
      :amzReplenishmentCode="amzReplenishmentCode"
      :isVc="isVc"
    />
  </div>
</template>
<script>
import SkuTable from '../components/sku-table'
import SetScmFbaTable from '../components/set-scm-fba-table'
export default {
  name: 'ecom-awsBiz-replenishmentList-detail',
  components: { SkuTable, SetScmFbaTable },
  data() {
    return { formData: {} }
  },
  computed: {
    params() {
      return this.$route.params
    },
    amzReplenishmentCode() {
      return this.params.code
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
    isVc() {
      const { skuSalesChannel } = this.formData
      return skuSalesChannel == 'V' ? 'Y' : 'N'
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzReplenishmentCode) return
      const params = { amzReplenishmentCode: this.amzReplenishmentCode }
      const res = await this.$api
        .ecomAmzReplenishmentDetailApi(params)
        .catch(() => null)
      this.formData = res?.body || {}
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
::v-deep {
  .el-tag--logistics {
    background-color: #f9f0ff !important;
    border-color: #d3adf7 !important;
    color: #732ed1 !important;
  }
}
</style>
